(function() {
  'use strict';

  // fire it up!
  angular
    .module(moduleConfig.applicationModuleName)

    .run([
      '$rootScope',
      'commonService',
      '$window',
      'provinceMeta',
      '$translate',
      '$state',
      '$stateParams',
      'uteModal',
      'amMoment',
      'cartManager',
      'util',
      '$modalStack',
      '$modal',
      'PCA_KEY',
      'notifierService',
      'tmhDynamicLocale',
      'uteLocale',
      'janrainService',
      '$location',
      'env',
      '$filter',
      'ute.datalayer.common.service',
      'qualtricsService',
      'timerService',
      '$injector',
      'signinService',
      'userService',
      '$timeout',
      'downgradedUserService',
      function(
        $rootScope,
        commonService,
        $window,
        provinceMeta,
        $translate,
        $state,
        $stateParams,
        uteModal,
        amMoment,
        cartManager,
        util,
        $modalStack,
        $modal,
        PCA_KEY,
        notifierService,
        tmhDynamicLocale,
        uteLocale,
        janrainService,
        $location,
        env,
        $filter,
        dataLayerService,
        qualtricsService,
        timerService,
        $injector,
        signinService,
        userService,
        $timeout,
        downgradedUserService
      ) {
        console.log('run started');

        uteModal.defaultConfigObject.opened = function() {
          try {
            dataLayerService.trackUteModal(uteModal.config);
          } catch (e) {
            console.warn('trackUteModal method: ', e);
          }
        };

        // make $state available in view
        $rootScope.state = $state;
        $rootScope.stateParams = $stateParams;

        // canada post key
        $rootScope.pcaKey = PCA_KEY;

        //DSO-15392
        $rootScope.promoOfferId = null;
        $rootScope.discountOffers = null;

        angular.extend($rootScope.constructor.prototype, {
          $extend: function(extension) {
            angular.extend(this, extension);
            return this;
          }
        });

        // declare rui methods on window into global $rootScope
        $rootScope.ruiMethods = {
          user: {
            is: {
              agent: function() {
                return !!$rootScope.userInfo.cfaInfo;
              },
              loggedIn: function() {
                return downgradedUserService.isLoggedIn();
              },
              showDashBoardLink: function() {
                return $rootScope.userInfo.isAccountLinked;
              }
            },
            services: function() {
              var services = [];

              if (commonService.customerHasWirelessService === true) services.push('wireless');
              if (commonService.customerHasInternetService === true) services.push('internet');
              if (commonService.customerHasTVService === true) services.push('tv');

              return services.join(' ');
            }
          },
          agent: {
            name: function() {
              return $rootScope.userInfo.cfaInfo.agentName;
            },
            shortName: function() {
              var agentName;
              var shortName;
              if (
                $rootScope &&
                $rootScope.userInfo &&
                $rootScope.userInfo.cfaInfo &&
                $rootScope.userInfo.cfaInfo.agentName
              ) {
                agentName = $rootScope.userInfo.cfaInfo.agentName;
              } else {
                agentName = '';
              }
              var split = agentName.split(' ');
              if ((split || []).length > 1) {
                shortName = split[0] + ' ' + split[split.length - 1].substring(0, 1);
              } else {
                shortName = agentName;
              }
              //Return first capital letter for the First & Last Name
              shortName = shortName.replace(/\w\S*/g, function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
              });
              return shortName;
            },
            repId: function() {
              return $rootScope.userInfo && $rootScope.userInfo.cfaInfo && $rootScope.userInfo.cfaInfo.userID
                ? $rootScope.userInfo.cfaInfo.userID
                : '';
            },
            storeCode: function() {
              return $rootScope.userInfo && $rootScope.userInfo.cfaInfo && $rootScope.userInfo.cfaInfo.storeCode
                ? $rootScope.userInfo.cfaInfo.storeCode
                : '';
            },
            storeName: function() {
              return $rootScope.userInfo && $rootScope.userInfo.cfaInfo && $rootScope.userInfo.cfaInfo.storeName
                ? $rootScope.userInfo.cfaInfo.storeName
                : '';
            },
            //UNIT 100 3633 WESTWINDS DRIVE NE$CALGARY$AB$T3J5K3
            storeAddress: function() {
              var add =
                $rootScope.userInfo && $rootScope.userInfo.cfaInfo && $rootScope.userInfo.cfaInfo.storeLocation
                  ? $rootScope.userInfo.cfaInfo.storeLocation
                  : '';
              if (add) {
                var split = add.split('$');
                if ((split || []).length === 4) {
                  if (split[3].length > 5) {
                    split[3] = split[3].substr(0, 3) + ' ' + split[3].substr(3);
                  }
                  return { address: split[0], city: split[1], province: split[2], postalCode: split[3] };
                }
                //Send complete address in address if less than 4 parts
                else {
                  return { address: add.replace(/\$/g, ' '), city: '', province: '', postalCode: '' };
                }
              }
              return { address: '', city: '', province: '', postalCode: '' };
            },
            homeURL: function() {
              if ($rootScope.userInfo && $rootScope.userInfo.cfaInfo && $rootScope.userInfo.cfaInfo.sourceURL) {
                return $rootScope.userInfo.cfaInfo.sourceURL + $rootScope.userInfo.cfaInfo.signOutURL;
              } else {
                return '';
              }
            },
            closeAccountURL: function() {
              return $rootScope.userInfo.cfaInfo.sourceURL
                ? $rootScope.userInfo.cfaInfo.sourceURL + $rootScope.userInfo.cfaInfo.closeAccountURL
                : '';
            },
            type: function() {
              return $rootScope.userInfo && $rootScope.userInfo.cfaInfo && $rootScope.userInfo.cfaInfo.agentType
                ? $rootScope.userInfo.cfaInfo.agentType
                : '';
            },
            creditCardSwipeEnabled: function() {
              return $rootScope.userInfo.cfaInfo.creditCardSwipeEnabled ? 'true' : 'false';
            },
            signOut: function(showMessage) {
              var path = '';

              if ($rootScope.userInfo && $rootScope.userInfo.cfaInfo && $rootScope.userInfo.cfaInfo.sourceURL) {
                path = $rootScope.userInfo.cfaInfo.sourceURL + $rootScope.userInfo.cfaInfo.signOutURL;

                if ($rootScope.userInfo.cfaInfo.signOutURL) {
                  path = path + $rootScope.userInfo.cfaInfo.signOutURL;
                }
              } else {
                path = '';
              }

              util.endAgentSession();

              if (!showMessage) {
                // if the url to ssp is not available, go to home of ute
                if (!path) {
                  $state.go('home');
                } else {
                  $window.location = path;
                }
              } else {
                var modalConfig = {
                  templateUrl: 'modules/user/views/session-expired.html',
                  controller: [
                    '$scope',
                    '$modalInstance',
                    function($scope, $modalInstance) {
                      $scope.message = showMessage;

                      $scope.ok = function() {
                        $modalInstance.close();
                      };

                      $scope.cancel = function() {
                        $modalInstance.dismiss('cancel');
                      };
                    }
                  ],
                  ok: function() {
                    // if the url to ssp is not available, go to home of ute
                    if (!path) {
                      $state.go('home');
                    } else {
                      $window.location = path;
                    }
                  },
                  cancel: function() {
                    // if the url to ssp is not available, go to home of ute
                    if (!path) {
                      $state.go('home');
                    } else {
                      $window.location = path;
                    }
                  }
                };

                // show modal
                uteModal.open(modalConfig);
              }
            },
            gotoHome: function() {
              var path = '';

              if ($rootScope.userInfo && $rootScope.userInfo.cfaInfo && $rootScope.userInfo.cfaInfo.sourceURL) {
                path = $rootScope.userInfo.cfaInfo.sourceURL;

                if ($rootScope.userInfo.cfaInfo.closeAccountURL) {
                  path = path + $rootScope.userInfo.cfaInfo.closeAccountURL;
                }
              } else {
                path = '';
              }

              util.endAgentSession();

              //if the url to ssp is not available, go to home of ute
              if (!path) {
                $state.go('home');
              } else {
                $window.location = path;
              }
            },
            agentFeedback: function() {
              //FSR.popFeedback('ssp');
              qualtricsService.openAgentFeedback(); //DSO-505
            },
            closeAccount: function() {
              var path = '';

              if ($rootScope.userInfo && $rootScope.userInfo.cfaInfo && $rootScope.userInfo.cfaInfo.sourceURL) {
                path = $rootScope.userInfo.cfaInfo.sourceURL + $rootScope.userInfo.cfaInfo.closeAccountURL;

                if ($rootScope.userInfo.cfaInfo.closeAccountURL) {
                  path = path + $rootScope.userInfo.cfaInfo.closeAccountURL;
                }
              } else {
                path = '';
              }

              util.endAgentSession();

              // if the url to ssp is not available, go to home of ute
              if (!path) {
                $state.go('home');
              } else {
                $window.location = path;
              }
            },
            has: {
              customerContext: function() {
                return (
                  $rootScope.ruiMethods.user.is.agent() &&
                  !!$rootScope.userInfo.accounts &&
                  _.size($rootScope.userInfo.accounts) > 0
                );
              }
            }
          },
          getProvinceServices: function() {
            return provinceMeta[uteLocale.province].services.join(' ');
          },
          toggleMobileMenu: function(force) {
            // console.log('toggleMobileMenu called...force?', force);
            // console.log('current menu open?', $rootScope.mobileNavOpen);
            // if theres no operation requested, do a pure toggle of the switch
            if (angular.isDefined(force)) {
              $rootScope.mobileNavOpen = force;
            } else {
              $rootScope.mobileNavOpen = !$rootScope.mobileNavOpen;
            }
            // console.log('current menu open?', $rootScope.mobileNavOpen);
          },
          serviceAvailable: function(service, province) {
            province = angular.isUndefined(province) ? uteLocale.province : province;
            return provinceMeta[province].services.indexOf(service) !== -1;
          },
          openModal: function(view) {
            var config = {};
            config.templateUrl = view;
            uteModal.open(config);
          },
          showMyAccountLink: function() {
            if (!$rootScope.ruiMethods.user.is.agent()) {
              // if user is customer, show link whether user logged in or not
              //return $rootScope.ruiMethods.user.is.loggedIn();
              return true;
            } else {
              // if user is agent
              return $rootScope.ruiMethods.agent.has.customerContext();
            }

            return false;
          },
          printDiv: function(divName) {
            if ($rootScope.ruiMethods.user.is.agent()) {
              window.print();
              /*called 2 times coz CFA need to print 2 times and we cannot override the print popup */
              //window.print();
            } else {
              window.print();
            }
            /*var printContents = document.getElementById(divName).innerHTML;
             var originalContents = document.body.innerHTML;

             if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
             var popupWin = window.open('', '_blank', 'width=600,height=600,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
             popupWin.window.focus();
             popupWin.document.write('<!DOCTYPE html><html><head>' +
             '<link rel="stylesheet" type="text/css" href="css/ute.css" /> <link rel="stylesheet" type="text/css" href="css/fido.css" />' +
             '</head><body onload="window.print()"><div class="reward-body">' + printContents + '</div></html>');
             popupWin.onbeforeunload = function (event) {
             popupWin.close();
             return '.\n';
             };
             popupWin.onabort = function (event) {
             popupWin.document.close();
             popupWin.close();
             };
             } else {
             var popupWin = window.open('', '_blank', 'width=800,height=600');
             popupWin.document.open();
             popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="css/ute.css" /><link rel="stylesheet" type="text/css" href="css/fido.css" /></head><body onload="window.print()">' + printContents + '</html>');
             popupWin.document.close();
             }
             popupWin.document.close();
             return true;*/
          },
          applyFilter: $filter
        };

        // an array of items that need to be bound to the $rootScope and need a watch for cookie update
        util.setCookiesOnRootScope([
          {
            windowObjName: '__userPref',
            rootScopeVarName: 'userPref',
            watchMethod: function(nv, ov) {
              // the value is new, update cookie
              if (nv !== ov && !_.isUndefined(nv) && !_.isEmpty(nv)) {
                var allProvinces = ['ab', 'bc', 'mb', 'nb', 'nl', 'ns', 'on', 'pe', 'qc', 'sk'];
                var allLanguages = ['en', 'fr'];
                var urlParamProv = $window.getParameterByName('setProvince');
                var urlParamLang = $window.getParameterByName('setLanguage');

                if (angular.isDefined(urlParamProv) && _.contains(allProvinces, urlParamProv.toLowerCase())) {
                  nv.urlProvParaExists = true;
                }

                if (angular.isDefined(urlParamLang) && _.contains(allLanguages, urlParamLang.toLowerCase())) {
                  nv.urlLangParaExists = true;
                }

                $window.setCookie(
                  'userPref',
                  nv,
                  {
                    expires: 30,
                    path: '/'
                  },
                  true
                );

                // if province has changed, reload window
                if (
                  angular.isDefined(nv.province) &&
                  angular.isDefined(ov.province) &&
                  nv.province.toString().toUpperCase() !== ov.province.toString().toUpperCase()
                ) {
                  $window.setCookie(
                    'province',
                    nv.province.toUpperCase(),
                    {
                      expires: 30,
                      path: '/'
                    },
                    false
                  );

                  $window.location.replace(env.fidoHomePageUrl); //all location province change redirect to root.
                }

                // if language has changed, reload window
                if (nv.language !== ov.language) {
                  $window.setCookie(
                    'language',
                    nv.language,
                    {
                      expires: 30,
                      path: '/'
                    },
                    false
                  );
                  $window.location.reload();
                }
              }
            },
            deepWatch: true
          },
          {
            windowObjName: '__atg',
            rootScopeVarName: 'atg',
            watchMethod: function(nv, ov) {
              // the value is new, update cookie
              if (nv !== ov && !_.isUndefined(nv)) {
                // need all attributes to be preset in atg cookie; SS passes expirations (-1 or timestamp)
                if (
                  nv.userId &&
                  nv.userId.name &&
                  nv.userId.value &&
                  nv.userId.expire &&
                  nv.hashKey &&
                  nv.hashKey.name &&
                  nv.hashKey.value &&
                  nv.hashKey.expire
                ) {
                  // secondary condition to update cookie: check if expiry is -1, store cookie if it is not
                  if (nv.userId.expire.toString() !== '-1') {
                    var expiry = null;

                    // do some math with moment
                    expiry = moment(nv.userId.expire).diff(moment(), 'days', true);

                    // set cookie with processed expiry
                    $window.setCookie(
                      'atg',
                      nv,
                      {
                        expires: expiry,
                        path: '/'
                      },
                      true
                    );
                  }

                  // fetch cart as soon as userId and hashKey are not 'default'
                  if (nv.userId.value != 'default' && nv.hashKey.value != 'default') {
                    cartManager.fetch();
                  }
                } else {
                  $window.deleteCookie('atg', true);
                }
              }
            },
            deepWatch: true
          },
          {
            windowObjName: '__userInfo',
            rootScopeVarName: 'userInfo',
            watchMethod: function(nv, ov) {
              // if set to empty string then delete userInfo cookie
              if (_.isEmpty(nv) || _.isUndefined(nv)) {
                console.log('deleting cookie', nv);
                $window.deleteCookie('userInfo', true);
              } else if (nv !== ov) {
                console.log('creating cookie', nv);

                if (_.has(nv, 'firstName') && nv.firstName === 'null') {
                  nv.firstName = '';
                }

                if (_.has(nv, 'lastName') && nv.lastName === 'null') {
                  nv.lastName = '';
                }

                // if user is agent, sync expiry with session timer
                if (nv.expiry) {
                  var expiry = moment().toDate();
                  if (nv.expiry !== ov.expiry) {
                    expiry = moment(nv.expiry).toDate();
                  }
                  $window.setCookie('userInfo', nv, { expires: expiry, path: '/' }, true);
                } else {
                  $window.setCookie('userInfo', nv, { path: '/' }, true);
                }
              }
            },
            deepWatch: true
          },
          {
            windowObjName: '__passiveTracking',
            rootScopeVarName: 'passiveTracking',
            watchMethod: function(nv, ov) {
              if (_.isEmpty(nv) || _.isUndefined(nv)) {
                $window.deleteCookie('passiveTracking', true);
              } else {
                // expiry?
                $window.setCookie('passiveTracking', nv, { path: '/' }, true);
              }
            },
            deepWatch: true
          }
        ]);

        // exception: $rootScope.shoppingCart.quantity needs to be stored as a cookie; so adding a watch
        $rootScope.$watch('shoppingCart.quantity', function(nv, ov) {
          if (nv !== ov) {
            // if quantity changes, update $rootScope.userPref.cartQuantity
            $rootScope.userPref.cartQuantity = nv;
            /* DSO-15392 start */
            //            var tierInCart = cartManager.internet.tierInCart();
            //            if(tierInCart && $rootScope.promoOfferId === null && !(commonService.customerHasInternetService && commonService.internetAccountStatus !== 'SUSPENDED' && commonService.internetAccountStatus !== 'CANCELLED')) {
            //              var isOfferIdEligible = buyService.isPromoOfferIdEligible(tierInCart.selectedOffer.offerId);
            //              if(isOfferIdEligible === null) {
            //                buyService.getInternetPromos().then(function(data) {
            //                  if(data) {
            //                    isOfferIdEligible = buyService.isPromoOfferIdEligible(tierInCart.selectedOffer.offerId);
            //                    $rootScope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
            //                  }
            //                });
            //              } else {
            //                $rootScope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
            //              }
            //            }
            /* DSO-15392 end */
          }
        });

        // fetch cart if there's something in cart cookie
        if ($rootScope.userPref.cartQuantity > 0) {
          cartManager.fetch();
        }

        if ($window.sessionStorage.getItem('sessionExpired') != null) {
          $location.url('/internet');
          $window.sessionStorage.removeItem('sessionExpired');
        }

        console.log('////////////////////////////////////');
        console.log('// setting locale');
        console.log('language:', uteLocale.language);
        console.log('province:', uteLocale.province);
        amMoment.changeLocale(uteLocale.language);

        $rootScope.translationReady = false;
        $translate.use(uteLocale.language).then(function(val) {
          $rootScope.translationReady = true;
        });
        tmhDynamicLocale.set(uteLocale.language + '-ca');
        console.log('////////////////////////////////////');

        // all route/state inteceptors declared below
        $rootScope.$on('$stateChangeStart', function(e, toState, toParams, fromState, fromParams) {
          try {
            var easylogin = $location.search().easylogin;
            if (
              ((!!easylogin && fromState.name && toState.name === 'myAccount.overview') ||
                fromState.name === 'signin') &&
              !commonService.loginProcessed
            ) {
              timerService.stopTimer();
              // user is authenticated, so stop session timer started for anon cx
              extractLoginInformation();
            }
          } catch (e) {
            console.log('Exception occurred in run.js: $rootScope.$on("$stateChangeStart",.. ):: ' + e);
          }
          //BuyFlow deeplinking check
          // Session Time out for Anonymous Customer
          if (!($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent())) {
            timerService.stopTimer();
            timerService.startTimer();
          } else {
            timerService.stopTimer();
          }
          // pre-requisites to being on the future state
          if (toState.data) {
            // if to state is not available for this province, go home instead
            if (toState.data.service && !$rootScope.ruiMethods.serviceAvailable(toState.data.service)) {
              e.preventDefault();
              // $state.go('home', {});
              $window.location.href = env.fidoHomePageUrl;
            }

            // if user isn't authenticated to be in the future state, go to login state, get credentials then redirect with params
            if (toState.data.authRequired && toState.data.authRequired === true) {
              //Allow buy flow only for logged in users or CFA with customer context
              if (
                toState.name === 'buy' ||
                toState.parent === 'buy' ||
                toState.name === 'fulfillment' ||
                toState.parent === 'fulfillment'
              ) {
                // is user NOT an agent or dont have customer context
                if (
                  $rootScope.ruiMethods.user.is.agent() === false ||
                  $rootScope.ruiMethods.agent.has.customerContext() === false
                ) {
                  // is user not authenticated
                  if (
                    $rootScope.ruiMethods.user.is.loggedIn() === false ||
                    $rootScope.userInfo.isAccountLinked === false
                  ) {
                    // e.preventDefault();
                    console.log('going to render login 1');
                    // if (($window.location.href || '').indexOf('#/signin') === -1) {
                    //   $window.setCookie('deepJSON', window.location.href, {path: '/', domain: '.fido.ca'});
                    // }
                    // janrainService.renderLogin(undefined, 'USER_NOT_LOGGED_IN');
                  }
                }
              } else {
                console.log('is agent:', $rootScope.ruiMethods.user.is.agent());
                console.log('is customer:', !$rootScope.ruiMethods.user.is.agent());
                console.log('logged in:', $rootScope.ruiMethods.user.is.loggedIn());
                //  DSO-11960 fix.
                // try {
                //   var easylogin = $location.search().easylogin;
                //   if (((!!easylogin && fromState.name && toState.name === 'myAccount.overview') || fromState.name === 'signin') && !commonService.loginProcessed) {
                //     timerService.stopTimer(); // user is authenticated, so stop session timer started for anon cx
                //     extractLoginInformation();
                //   }
                // } catch (e) {
                //   console.log('Exception occurred in run.js: $rootScope.$on("$stateChangeStart",.. ):: ' + e);
                // }
                // is user NOT an agent
                // if ($rootScope.ruiMethods.user.is.agent() === false) {
                //   // is user not authenticated
                //   if ($rootScope.ruiMethods.user.is.loggedIn() === false || $rootScope.userInfo.isAccountLinked === false) {
                //     // e.preventDefault();
                //     //$state.go('home', {
                //     //  redirectState: toState,
                //     //  redirectParams: toParams
                //     //});
                //     if (toState.name === 'reservedevice') {
                //       $state.current.name = 'reservedevice';
                //     }
                //     // console.log('going to render login 2');
                //     // if (($window.location.href || '').indexOf('#/signin') === -1) {
                //     //   $window.setCookie('deepJSON', window.location.href, {path: '/', domain: '.fido.ca'});
                //     // }
                //     // janrainService.renderLogin(undefined, 'USER_NOT_LOGGED_IN');
                //
                //   }
                // }
              }
            }

            // if user isn't authenticated to be in the future state, go to login state, get credentials then redirect with params
            if (toState.data.janrainAuthRequired && toState.data.janrainAuthRequired === true) {
              if ($rootScope.userInfo.isAccountLinked === true || $rootScope.userInfo.isAccountLinked === undefined) {
                e.preventDefault();

                if ($rootScope.ruiMethods.user.is.loggedIn()) {
                  $state.go('myAccount.overview', {
                    redirectState: toState,
                    redirectParams: toParams
                  });
                } else {
                  //$state.go('home', {
                  //  redirectState: toState,
                  //  redirectParams: toParams
                  //});

                  console.log('going to render login 3');
                  if (($window.location.href || '').indexOf('#/signin') === -1) {
                    $window.setCookie('deepJSON', window.location.href, { path: '/', domain: '.fido.ca' });
                  }
                  janrainService.renderLogin(undefined, 'USER_NOT_LOGGED_IN');
                }
              }
            }

            // if ($rootScope.ruiMethods.user.is.loggedIn()) {
            if (util.getParameterByName('bfa') === 'true') {
              commonService.bfaDeepLinkURL = util.getDeeplink('referer');
              // if (url) {
              //   commonService.hupdeepLinkURL = url;
              // } else {
              //   // janrainService.renderLogin();
              // }
            }
            // }

            // if there's a redirect set for the future state, redirect instead
            if (toState.redirectTo && toState.redirectTo !== '') {
              e.preventDefault();
              $state.go(toState.redirectTo);
              return;
            }
            //open Pay Now enhancement modal on previous state view
            if (
              $rootScope.ruiMethods.user.is.loggedIn() &&
              (toState.name == 'myAccount.payNowEnhancement' ||
                toState.name == 'myAccount.payNowInteracEnhanceResponse')
            ) {
              e.preventDefault();
              uteModal
                .open({
                  templateUrl: 'modules/my-account/pay-now-redesign/pay-now.html',
                  windowTemplateUrl: 'views/templates/modal/pop-up-window-modal.html',
                  controller: 'enhancedPayNowCtrl',
                  windowClass: 'pay-now-modal-window',
                  data: toParams,
                  size: 'lg',
                  backdrop: 'static',
                  keyboard: false
                })
                .result.then(function(data) {
                  if (!!data && data.paymentStep === 'Confirmation' && data.billingType === 'Creditcard') {
                    commonService.getAccountDetails($rootScope.userInfo.accounts, false, true).then(function() {
                      $state.reload();
                    });
                  }
                })
                .finally(function() {
                  //Pay now deeplink -> on modal close redirect to view bill page
                  if (
                    commonService.initialDeepLinkURL &&
                    commonService.initialDeepLinkURL.indexOf('pay-now') >= 0 &&
                    angular.isDefined($rootScope.userInfo.profileType.subscriber) &&
                    !$rootScope.userInfo.profileType.subscriber
                  ) {
                    commonService.initialDeepLinkURL = '';
                    $state.go('myAccount.viewInvoice');
                  }
                });
            }

            //check if coming from easy login and deepJSON is processed
            // if ($window.localStorage.getItem('deepLinkProcessed') && !commonService.loginProcessed) {
            //   executeAfterJanrainLoad();
            // }
          }
        });

        $rootScope.$on('$stateChangeSuccess', function(evt, toState, toParams, fromState, fromParams) {
          //Run the Qualtrics code
          if (typeof window.QSI !== 'undefined') {
            setTimeout(function() {
              window.QSI.API.unload();
              window.QSI.API.load();
              window.QSI.API.run();
            }, 500);
          }

          $rootScope.stateName = $location.path().replace('/', '');

          var scrollView = true;

          // set current state name
          $rootScope.currentState = toState;
          $rootScope.pageDescription = ' ';
          $rootScope.pageKeywords = ' ';
          $rootScope.pageBrandName = '| Fido.ca';

          if ($rootScope.currentState) {
            $translate('global.pageDescription.' + $rootScope.currentState.title).then(function(translatedValues) {
              $rootScope.pageDescription = translatedValues;
            });

            $translate('global.pageKeywords.' + $rootScope.currentState.title).then(function(translatedValues) {
              $rootScope.pageKeywords = translatedValues;
            });

            if ($rootScope.currentState.title === 'internet') {
              $rootScope.pageBrandName = '| Fido';
            }
          }

          if (toState && (toState.angularRoute === true || (toState.data && toState.data.authRequired))) {
            timerService.stopTimer(); // stop timer when upgraded angular route is loaded
          }
          if (fromState && fromState.angularRoute === true && toState && !toState.angularRoute) {
            $timeout(function() {
              var ngRouter = $injector.get('ngRouter');
              ngRouter.navigateByUrl(toState.url, { skipLocationChange: true });
            });
          }
          //set previous state name
          $rootScope.previousState = fromState;

          //remove dots from current state
          //$rootScope.currentStateNew = $rootScope.currentState.name.replace(/\./g,'_');
          // close mobile nav
          $rootScope.ruiMethods.toggleMobileMenu(false);

          // close all modal when new state starts
          if (!(userService.isResetPasswordModalOpen || userService.isAutoRegModalOpen)) {
            $modalStack.dismissAll();
          }

          // open a modal when required
          if ($rootScope.modal) {
            $modal.open({ templateUrl: $rootScope.modal });
            $rootScope.modal = undefined;
          }

          if (fromState['parent'] === 'app' && toState['parent'] === 'app') {
            // if states are top level, they will both have the same parent state 'app'
            scrollView = true;
          } else if (fromState['parent'] === toState['parent'] && toState.data && toState.data.scrollToTop == false) {
            // if states are not top level, read the scrollToTop value from state.data
            scrollView = false;
          } else {
            scrollView = true;
          }

          if (scrollView === true) $window.scrollTo(0, 0);

          if (signinService.getLoadingIndicator() && $rootScope.ruiMethods.user.is.loggedIn()) {
            signinService.setLoadingIndicator(false);
          }
        });

        // $rootScope.$on('$stateChangeError', function (evt, toState, toParams, fromState, fromParams, error) {
        //   // TODO: tbd a service to handle error cases
        //   // notifierService.notify('technical');
        // });
        //
        // $rootScope.$on('$stateNotFound', function (evt, unfoundState, fromState, fromParams) {
        //   // TODO: tbd a service to handle error cases
        //   // notifier.notify.error();
        // });

        // rule to disable links with 'disabled' class
        $('.disabled').on('mouseHover', function(e) {
          e.preventDefault();
        });
        //Logout user after session expires
        $rootScope.$on('IdleTimeout', function() {
          $('#grayOut').hide();
          commonService.logOutUser(false, 'global.message.sessionExpiredLoginAgain', 'login');
        });

        console.log('run finished');

        //Start Login Modal Easy Login BRT implementation
        // var easylogin = $location.search().easylogin;
        // if (easylogin != undefined && easylogin == 'true') {
        //   $window.localStorage.setItem('allowEasyLogin', 'true');
        //
        //   var isLoggedIn = $location.search().loggedIn;
        //   if (isLoggedIn && isLoggedIn === 'true') {
        //     $state.go('myAccount.overview');
        //   }
        // }

        //End Login Modal Easy Login BRT implementation

        /**
         *
         * This method binds message communication event from window
         * @param event
         */
        function trackSecondaryLogin(event) {
          var org = ''.concat(event.origin).match(/fido.ca/);
          if (org && org.length === 0) {
            return; // break to prevent XSS if not from same origin
          }
          if (event.data) {
            if (event.data.easyLoginMethod) {
              switch (event.data.easyLoginMethod) {
                case 'redirect':
                  var secondarySigninPayload = sessionStorage.getItem('secondarySigninPayload');
                  if (secondarySigninPayload) {
                    try {
                      var secondarySigninJSONPayload = JSON.parse(secondarySigninPayload);
                      if (secondarySigninJSONPayload && secondarySigninJSONPayload.loginSucceeded === true) {
                        if (
                          $window._trackData &&
                          $window.tmsObjects &&
                          $window.tmsObjects.afterAACall &&
                          $window.tmsObjects.afterAACall.registerEvent
                        ) {
                          var trackSecondarySignin = function() {
                            $window._trackData({
                              miscellaneous: {
                                type: secondarySigninJSONPayload.signinTypeSuccess,
                                name: 'secondary-signin-success'
                              },
                              events: {
                                miscellaneous: true
                              }
                            });
                            $window.sessionStorage.removeItem('secondarySigninPayload');
                          };
                          $window.tmsObjects.afterAACall.registerEvent(trackSecondarySignin, {});
                        } else {
                          $window.sessionStorage.removeItem('secondarySigninPayload');
                        }
                      }
                    } catch (ex) {
                      $window.sessionStorage.removeItem('secondarySigninPayload');
                      console.warn('error tracking secondary signin attempt');
                    }
                  }
                  break;
                default:
                  break;
              }
            }
          }
        }

        function extractLoginInformation() {
          $window.localStorage.removeItem('deepLinkProcessed');
          //make sure to delete deepJSON cookie
          try {
            var loginData = JSON.parse($window.localStorage.getItem('easyLoginDataJanrain'));
            if (!$rootScope.userInfo.uuid) {
              $rootScope.userInfo.uuid = loginData.uuid;
              $rootScope.userInfo.userID = loginData.userID;
            }
            commonService.accessToken = loginData.accessToken;
            commonService.loginProcessed = true;
            $.cookie('deepJSON', '', { path: '/pages', expires: -1 });
            $.cookie('deepJSON', '', { path: '/', domain: '.fido.ca', expires: -1 });
            signinService.setLoadingIndicator(true);
            downgradedUserService.proceedWithLogin();
          } catch (error) {
            console.log('el => deleting deepJSON cookie from all possible paths');
          }
        }

        $window.addEventListener('message', trackSecondaryLogin, false);
      }
    ]);
})();
